<template>
  <div class="page">
    <m-header title="餐厅详情" subText=""/>
    <div class="page-content shopDetail">
        <div class="title">{{shopDetail[0].restaurantName}}</div>
        <mt-cell class="notRequired" :title="item.dishName" :value="item.priceInCent | priceInCent" v-for="(item,index) in productList" :key="index"></mt-cell>
        <div class="noContent" v-if="!productList.length">该餐厅空空如也</div>
    </div>       
  </div>
</template>

<script>    
    import { mapGetters, mapMutations, mapActions } from 'vuex'
    export default {
        data() {
            return {
                shopDetail: {},
                productList:[]
            }
        },
        created() {
            let restaurantId = this.$route.query.restaurantId
            console.log(restaurantId)
            this.shopDetail = this.shopList.filter((item)=>{
                return item.restaurantId == restaurantId
            })
            console.log(this.shopDetail)
            this.getRestaurantList()

        },
        computed: {
            ...mapGetters([
                'shopList'
            ])
        },        
        methods: {
            getRestaurantList() {
                this.productList = []
                let sectionList = this.shopDetail[0].sectionList || [];
                for(let i = 0; i<sectionList.length; i++) {
                    let dishList = sectionList[i].dishList;
                    for(let j = 0; j<dishList.length; j++) {
                        console.log(dishList[j])
                        //   dishList[j].priceInCent = "¥"+ ((dishList[j].priceInCent)/100).toFixed(2);   
                          this.productList.push(dishList[j])  
                    }
                }
                console.log(this.productList)
            }  
        },
        filters: {
            priceInCent: (value) => {
                return "¥"+ (value/100).toFixed(2)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.shopDetail {
    .title{
        padding:16px 0;
        text-align:center;
    }
    .noContent{
        text-align:center;
        font-size:14px;
        padding-top:50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/takeOutShopDetail.vue